var path = '/app/webpack/wealthbar/components/filters/filter_deselect/filter_deselect.html.slim';
var html = "<div class=\"filter-deselect\" ng-click=\"ctrl.deselectFilters()\">Deselect all filters<i class=\"wbf wbf-close\"></i></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;